/* eslint-disable array-callback-return */
import { Component } from 'react'
import { RouterProps, withRouter } from '../../../../../insfrastructure/utils/with-router-component'
import { StaticValues } from '../../../../../insfrastructure/services/static_values'
import { listJobTitles } from '../../../../../insfrastructure/services/jobs-titles'
import { listBenefits } from '../../../../../insfrastructure/services/benefits'
import { listCourses } from '../../../../../insfrastructure/services/courses'
import { createJob, updateJob } from '../../../../../insfrastructure/services/jobs'
import ResponseModal from '../../../../components/response-modal'
import { SubmitBtn } from '../../../../components/submit'
import { BasicInfoForm } from '../basic-info'
import { BenefitsForm } from '../benefits'
import { RequirementsForm } from '../requirements'
import editImg from '../../../../../assets/icons/edit.png'
import './styles.sass'

interface Props {
  jobpost_id: number,
  basic_info: BasicInfoForm,
  benefits: BenefitsForm,
  requirements: RequirementsForm,
  changeSection: (index: number) => void
}

interface AllPropos extends Props, RouterProps {}

class Summary extends Component<AllPropos> {
  state: Record<string, any> = {
    job_types: {},
    job_titles: {},
    benefits: {},
    education_levels: {},
    courses: {},
    skills: {}
  }

  BRLReal = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  componentDidMount() {
    this.getStaticValues();
    this.listJobTitles();
    this.listBenefits();
  }

  getStaticValues = async () => {
    try {  
      const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;

      let skills: any = {};
 
      staticValues.skills.map(item => {
        skills[item.id] = item.name;
      });
      
      this.setState({ job_types: staticValues.job_type, education_levels: staticValues.education_level, skills, courses: staticValues.em_course });
    } catch (error) {}
  }

  listJobTitles = async () => {
    try {
      const response = await listJobTitles();
      
      let job_titles: any = {};

      response.results.map(item => {
        job_titles[item.id] = item.name;
      });

      this.setState({ job_titles });
    } catch (error) {}
  }

  listBenefits = async () => {
    try {        
      let benefits: any = {};

      const response = await listBenefits();

      response.results.map(item => {
        benefits[item.id] = item.name;
      });

      this.setState({ benefits });
    } catch (error) {}
  }

  async listCourses() {
    try {
      const results = await listCourses();

      let courses: any = {};
      
      results.results.map(item => {
        courses[item.id] = item.course_name;
      });

      this.setState({ courses });
    } catch (error) {}
  }

  onSubmit = async () => {
    if(this.state.loading) return;

    try {
      console.log(this.props);
    
      const form: any = {
        ...this.props.basic_info,
        ...this.props.benefits,
        ...this.props.requirements,
        company_id: localStorage.getItem('company_id'),
        minimum_experience: parseInt(this.props.requirements.minimum_experience)
      };

     form.skills = [...form.required_skills.map((skill: any) => ({ skill_id: skill, skillType: "REQUIRED" })), ...form.desired_skills.map((skill: any) => ({ skill_id: skill, skillType: "DESIRED" }))];

      console.log(form);
    
      this.setState({ loading: true });

      !this.props.jobpost_id ? await createJob(form) : await updateJob(this.props.jobpost_id, form);

      setTimeout(() => {
        let responseData = {
            type: 'success',
            title: 'Vaga criada com sucesso!'
        };
    
        this.setState({ loading: false, responseData });
      }, 500);
    } catch (error) {
      setTimeout(() => {
        let responseData = {
            type: 'error',
            title: 'Erro ao criar vaga'
        };
    
        this.setState({ loading: false, responseData });
      }, 500);
    }
  }

  render() {
    return (
      <div className='summary'>
        <div className='section basic-info-section'>
          <div className='section-header'>
            <h4>Dados básicos:</h4>
            <div className='edit' onClick={() => this.props.changeSection(1)}>
              <img src={editImg} alt='edit-icon' />
              <span>Editar</span>
            </div>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Nome da vaga:</p>
              <b>{this.state.job_titles[this.props.basic_info.job_title_id]}</b>
            </div>
            <div className='column'>
              <p>Quantidade de vagas:</p>
              <b>{this.props.basic_info.quantity} vaga{this.props.basic_info.quantity > 1 ? 's' : ''}</b>
            </div>
            <div className='column'>
              <p>Tipo de contratação:</p>
              <b>{this.state.job_types[this.props.basic_info.job_type?.toLowerCase()]}</b>
            </div>
          </div>
          {/* <div className='location-section'>
              <div className='location-title'>
                <img src={locationImg} alt='location-icon' />
                <p>Localização</p>
              </div>
              <b>{this.props.basic_info.street},{this.props.basic_info.number} - {this.props.basic_info.neighborhood}, {this.props.basic_info.city}, {this.props.basic_info.uf} - {this.props.basic_info.cep}</b>
          </div> */}
          <div className='about-section'>
            <h4>Sobre a vaga:</h4>
            <div dangerouslySetInnerHTML={{__html: this.props.basic_info.job_description}} />
          </div>
        </div>
        <div className='section benefits-section'>
          <div className='section-header'>
            <h4>Salário e benefícios:</h4>
            <div className='edit' onClick={() => this.props.changeSection(2)}>
              <img src={editImg} alt='edit-icon' />
              <span>Editar</span>
            </div>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Salário:</p>
              <b className='salary'>
                {
                  this.props.benefits.show_salary ?
                  this.BRLReal.format(this.props.benefits.salary) : 
                  'À combinar'
                }
              </b>
            </div>
            <div className='column'>
              <p>Benefícios:</p>
              <div className='selections'>
                {this.props.benefits.benefits.map((benefit) =>
                <b className='selection'>{this.state.benefits[benefit.benefit_id]}</b>)}
              </div>
            </div>
          </div>
        </div>
        <div className='section requirements-section'>
          <div className='section-header'>
            <h4>Requisitos:</h4>
            <div className='edit' onClick={() => this.props.changeSection(3)}>
              <img src={editImg} alt='edit-icon' />
              <span>Editar</span>
            </div>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Escolaridade:</p>
              <b>{this.state.education_levels[this.props.requirements.minimum_education]}</b>
            </div>
            <div className='column'>
              <p>Experiência mínima:</p>
              <b>{
                this.props.requirements.minimum_experience === '0' ? 
                'Indiferente' : 
                `${parseInt(this.props.requirements.minimum_experience)} ${parseInt(this.props.requirements.minimum_experience) < 2 ? 'ano' : 'anos'}`
              }</b>
            </div>
          </div>
          <div>
            <p>Habilidades obrigatórias:</p>
            <div className='selections'>
              {this.props.requirements.required_skills.map((skill: any) =>
              <b key={'required_skill_'+skill} className='selection'>{this.state.skills[skill]}</b>)}
            </div>
          </div>
          <div>
            <p>Habilidades opcionais:</p>
            <div className='selections'>
              {this.props.requirements.desired_skills.map((skill: any) =>
              <b key={'desired_skill_'+skill} className='selection'>{this.state.skills[skill]}</b>)}
            </div>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Cursos recomendados:</p>
              <div className='selections'>
                {this.props.requirements.recommended_courses.map((course) =>
                <b key={'course_'+course} className='selection'>{this.state.courses[course+'']}</b>)}
              </div>
            </div>
          </div>
        </div>
        <SubmitBtn className='primary' text='Confirmar' loadingText='Enviando...' loading={this.state.loading} onSubmit={this.onSubmit} />
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => {
          this.setState({ responseData: null });
          this.state.responseData?.type === 'success' && this.props.navigate('/offers');
        }} />
      </div>
    )
  }
}

export default withRouter(Summary);